<template>
  <base-bar-chart
    v-if="showChart"
    :chart-data="dataCollection"
    :options="options"
    style="max-height: 250px;"
  />
</template>
  <script>
    import moment from 'moment';
    import { isProjectIssuesDataExist } from 'src/helpers/chart-data-helper';

    export default {
      name: 'ProjectIssuesCounts',
      filters: {
        diffHumans (val) {
          return moment(val).fromNow();
        },
        convertToLocal (stringDatetime) {
          return moment(stringDatetime).local().format('Do MMMM YYYY');
        },
      },
      data: () => ({
        label: 'Total Issues',
        currentDateTime: moment(),
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            labels: {
              fontColor: '#000',
              fontsize: 14,
            },
          },
          scales: {
            yAxes: [{
              ticks: {
                fontColor: '#000',
                min: 0,
                stepSize: 50,
              },
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'My Sites',
                fontColor: '#000',
              },
              ticks: {
                display: false,
                fontColor: '#000',
              },
            }],
          },
        },
      }),
      computed: {
        chartData () {
          return this.$store.getters['dashboard/getProjectIssuesCounts'];
        },
        dataExist () {
          return this.chartData.length > 0;
        },
        showChart () {
          return Object.keys(this.dataCollection).length > 0;
        },
        dataCollection () {
          if (this.dataExist === false) {
            return {};
          }
          return this.generateDataCollection();
        },
        noDataExist () {
          const dataExist = isProjectIssuesDataExist(this.chartData);
          if (dataExist === true) {
            return false;
          }
          return true;
        },
        lastUpdatedAt () {
          return this.$store.getters['dashboard/getLastUpdatedAt'];
        },
      },
      mounted () {
        this.fetchProjectIssuesChartData();
      },
      methods: {
        async fetchProjectIssuesChartData () {
          await this.$store.dispatch('dashboard/fetchProjectIssuesCounts');
        },
        generateDataCollection () {
          const actionCount = [];
          const labels = [];
          for (const result of this.chartData) {
            labels.push(result.project.name);
            actionCount.push(result.total_issues);
          }
          return {
            labels: labels,
            datasets: [
              {
                data: actionCount,
                label: this.label,
                backgroundColor: '#674ADD',
                fill: false,
                barThickness: 40,
                borderRadius: 10,
              },
            ],
          };
        },
      },
    };
  </script>
  <style scoped>
  .alert-style {
    color: #C62828;
    text-align: center;
  }
  .my-card-title-style {
    color: #37474F;
    margin-left: 7px;
    margin-top: 10px;
    font-size: 18px;
  }
  .my-card-subtitle-style {
    color: #37474F;
    margin-left: 7px;
    margin-top: 7px;
    font-size: 14px;
  }
  .my-updation-text-style {
    color: #37474F;
    font-size: 12px;
  }
  </style>
